import ICustomErrorMessageProps from "components/CustomErrorMessage/ICustomErrorMessageProps";

import "./CustomErrorMessage.css";

const CustomErrorMessage: React.FC<ICustomErrorMessageProps> = ({ text, visible }) => {
	return (
		<div style={{ visibility: visible ? "visible" : "hidden" }} className={"custom-error-message"} role="dialog" aria-label="Error message">
			{text}
		</div>
	);
};

export default CustomErrorMessage;
